import APITemplate from '@/api/APITemplate'

const url = '/api/facility'

const template = APITemplate(url)
export default {
  ...template
}
